import { render, staticRenderFns } from "./livevideo.vue?vue&type=template&id=63d47296&"
import script from "./livevideo.vue?vue&type=script&lang=js&"
export * from "./livevideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports